import React, { useEffect, useState } from "react";
import Select from 'react-select'
import { useDispatch } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import { SlIcon, SlTabGroup, SlTab, SlDrawer } from "@shoelace-style/shoelace/dist/react";
import closeSvg from "../../assets/images/uncheck.svg";
import api from "../../services/api";
import YearlyCalendar from "../../shared/YearlyCalendar";
import NoDataFound from "../../shared/NoDataFound";
import CryptoJS from "crypto-js";
import TableLoader from "../../shared/TableLoader";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import filterSvg from "../../assets/images/filter.svg";
import chevronUp from "../../assets/images/chevron-up.svg";
import chevronDown from "../../assets/images/chevron-down.svg";
import { Toast } from "../../shared/Toast";
import {alphabets, BrandsTypes, InteractionTypeProps, languageOptions, roles } from "../../utils/constants";
import { getGenerateUrl } from "../../utils/constants";
import { SlTooltip } from "@shoelace-style/shoelace/dist/react";
import config from "../../config";
import * as XLSX from "xlsx";
import {saveAs} from 'file-saver'
import ScrollContainer from "react-indiana-drag-scroll";


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

export const options = {
  plugins: {
    title: {
      display: true,
      text: "All Values are in Lakhs",
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      callbacks: {
        // Customize the title
        title: (tooltipItems) => {
          return `Data for ${tooltipItems[0].label}`;
        },
        // Customize the label
        label: (tooltipItem) => {
          const dataset = tooltipItem.dataset;
          const label = dataset.label;
          const value = tooltipItem.raw;
          const bgColor = dataset.backgroundColor;
          return `${label}: ${value.toFixed(4)} Lakhs`;
        },
        // Customize footer
        footer: (tooltipItems) => {
          const total = tooltipItems.reduce((sum, item) => sum + item.raw, 0);
          return `Total: ${total.toFixed(4)} Lakhs`;
        },
      },
      backgroundColor: "rgba(0, 0, 0, 0.8)", // Background color
      titleFont: { size: 14, weight: "bold" }, // Title font
      bodyFont: { size: 12 }, // Body font
      footerFont: { size: 10, style: "italic" }, // Footer font
      padding: 10, // Padding inside tooltip
      cornerRadius: 4, // Tooltip border radius
      // Use the caretPadding to ensure the colors and labels are displayed correctly
      caretPadding: 10,
      bodyColor: "rgba(255, 255, 255, 1)", // Font color
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};
export const interactionGraphoptions = {
  plugins: {
    title: {
      display: true,
      // text: "All Values are in Lakhs",
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      callbacks: {
        // Customize the title
        title: (tooltipItems) => {
          return `Data for ${tooltipItems[0].label}`;
        },
        // Customize the label
        label: (tooltipItem) => {
          const dataset = tooltipItem.dataset;
          const label = dataset.label;
          const value = tooltipItem.raw;
          const bgColor = dataset.backgroundColor;
          return `${label}: ${value}`;
        },
        // Customize footer
        footer: (tooltipItems) => {
          const total = tooltipItems.reduce((sum, item) => sum + item.raw, 0);
          return `Total: ${total}`;
        },
      },
      backgroundColor: "rgba(0, 0, 0, 0.8)", // Background color
      titleFont: { size: 14, weight: "bold" }, // Title font
      bodyFont: { size: 12 }, // Body font
      footerFont: { size: 10, style: "italic" }, // Footer font
      padding: 10, // Padding inside tooltip
      cornerRadius: 4, // Tooltip border radius
      // Use the caretPadding to ensure the colors and labels are displayed correctly
      caretPadding: 10,
      bodyColor: "rgba(255, 255, 255, 1)", // Font color
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};


const labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

function MarketShareAnalysis() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  dispatch(SetComponentId(36));
  let salesUserType = ""
  if (localStorage.getItem('role') === roles.salesperson && localStorage.getItem('salesTabFlag')) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(localStorage.getItem('salesTabFlag'), config.B2B_SECRET_KEY);
    salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8)
  }
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const OpsSales = useSelector((state) => state.Head.opssales);
  const searchWord = useSelector((state) => state.Head.adssearch)
  const [all, setAll] = useState(false);
  const [showGrpah, setShowGraph] = useState(false);
  const [marketData, setMarketData] = useState([]);
  const [clickIndex, setClickIndex] = useState(-1);
  const [graphData, setGraphData] = useState([]);
  const [interactionsGraphData, setInteractionsGraphData] = useState([])
  const [totalInteractionsGraphDetails,setTotalInteractionsGraphDetails] = useState([])
  const [loader, setLoader] = useState(false);
  const [language, setLanguage] = useState("0");
  const [newspaperData, setNewsPaperData] = useState([]);
  const [brandId, setBrandId] = useState();
  const currentdate = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
  const [activeStatus, setActiveStatus] = useState(true)

  const [monthGraphData, setMonthGraphData] = useState({labels,
    datasets: [
    ],
  });
  const [monthInteractionGraphData, setMonthInteractionGraphData] = useState({labels,
    datasets: [
    ],
  });
  const [selectedList, setSelectedList] = useState(localStorage.getItem("selectedSalesList") && JSON.parse(localStorage.getItem("selectedSalesList")).length ? salesUsersList.filter(item => JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(item.value)) : salesUsersList?.length > 1 ? [] : []);
  const [salesPerson_id, setSalesPerson_id] = useState(salesUsersList?.length > 1 ? (localStorage.getItem("selectedSalesList") && JSON.parse(localStorage.getItem("selectedSalesList")).length ? (salesUsersList.filter(item => JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(item.value))[0]?.value || -1) : (salesUsersList[0]?.value) ) : -1);
  const [initialRender, setIntialRender] = useState(true)
  const [sortOn, setSortOn] = useState({
    sortBy: "amount",
    sortOrder: "desc",
  });
  const [showFilter, setShowFilter] = useState(false);
  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
    salesUsersList.map((item) =>{
      return item?.label[0]?.toUpperCase()
    }
    ).sort()
  )]);
  const [searchFilter, setSearchFilter] = useState('')
const [showUsersFilter, setShowUsersFilter] = useState( false
    // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
  )
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)

  const [columnWidths, setColumnWidths] = useState({});
  const fetchNewsPapers = async () => {
    try {
      let res = await api({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([
          ...res.data
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const filteredNewspapers = newspaperData.filter((np) => {
    // Include "Way2news" for Telugu, Tamil, and All languages
    if (np.name.toLowerCase() === "way2news") {
      return true;
    }
    return `${np.language}` === language || language === "0";
  });
  function formatAmount(amount) {
    if (isNaN(amount) || amount === undefined || amount === null) {
      return 0;
    }
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(3) + " Cr";
    } else  {
      return (amount / 100000).toFixed(2) + " L";
    }
  }
  function calculateAmountAndPercentage(data, src_name, total_amount) {
    // Ensure total_amount is positive to avoid division by zero
    total_amount = total_amount > 0 ? total_amount : 1;

    // Find the specific source (newspaper) in the data array
    const source = data.find((item) => item.newspaper_name === src_name);

    // Function to format the amount in appropriate units
    function formatAmount(amount) {
      if (isNaN(amount) || amount === undefined || amount === null) {
        return 0;
      }
      if (amount >= 10000000) {
        return (amount / 10000000).toFixed(3) + " Cr";
      } else{
        return (amount / 100000).toFixed(2) + " L";
      } 
      // else if (amount >= 1000) {
      //   return (amount / 1000).toFixed(2) + " K";
      // } else {
      //   return amount ? amount.toFixed(2) : 0;
      // }
    
  }

    // If the source exists in the data
    if (source) {
      // Calculate the percentage of the total amount
      const percentage = (source.amount / total_amount) * 100;

      // Determine the width class for the percentage bar
      const barWidthClass =
        percentage > 0 ? `w-[${parseInt(percentage)}%]` : "";

      // Format the amount and percentage
      const formattedAmount = formatAmount(source.amount);
      const percentageInteger = parseInt(
        percentage.toFixed(2).replace(".", "")
      );
      const formattedPercentage =
        percentageInteger % 100 === 0
          ? (percentageInteger / 100).toString()
          : percentage.toFixed(2);
      // Return the results
      return {
        exists: true,
        amt:source.amount || 0,
        amount: formattedAmount,
        percentage: formattedPercentage,
        barWidthClass,
      };
    } else {
      // If the source does not exist in the data
      return {
        exists: false,
        amount: "0",
        percentage: "0",
        barWidthClass: "",
      };
    }
  }
  function calculateAmountAndPercentageForInteractions(type) {
    // Ensure total_amount is positive to avoid division by zero
    let {total_count} = totalInteractionsGraphDetails;
    total_count = total_count > 0 ? total_count : 1;

    // If the source exists in the data
    if (+totalInteractionsGraphDetails[type]) {
      // Calculate the percentage of the total amount
      const percentage = (+totalInteractionsGraphDetails[type] / total_count) * 100;

      // Determine the width class for the percentage bar
      const barWidthClass =
        percentage > 0 ? `w-[${parseInt(percentage)}%]` : "";

      // Format the amount and percentage
      const percentageInteger = parseInt(
        percentage.toFixed(2).replace(".", "")
      );
      const formattedPercentage =
        percentageInteger % 100 === 0
          ? (percentageInteger / 100).toString()
          : percentage.toFixed(2);
      // Return the results
      return {
        exists: true,
        total_count: +totalInteractionsGraphDetails[type],
        percentage: formattedPercentage,
        barWidthClass,
      };
    } else {
      // If the source does not exist in the data
      return {
        exists: false,
        total_count: "0",
        percentage: "0",
        barWidthClass: "",
      };
    }
  }
  // Function to construct objects month-wise for each type
  function constructObjects(data) {
    const months = {};
    data.forEach((monthData) => {
      const month = new Date(monthData.month * 1000).getMonth() + 1; // Convert timestamp to month (1-indexed)
      const typesData = monthData.data.reduce((acc, item) => {
        acc[item.newspaper_name] = { count: item.count, amount: item.amount };
        return acc;
      }, {});
      // Initialize months object if not already present
      if (!months[month]) {
        months[month] = {
          Way2news: { count: 0, amount: 0 },
        };

        if (language === "1" || language === "0") {
          months[month].Eenadu = { count: 0, amount: 0 };
          months[month].Sakshi = { count: 0, amount: 0 };
        }
        if (language === "2" || language === "0") {
          months[month].Dinamalar = { count: 0, amount: 0 };
          months[month].Dinathanthi = { count: 0, amount: 0 };
        }
      }

      // Update months object with types data
      Object.keys(typesData).forEach((type) => {
        months[month][type] = {
          count: typesData[type].count,
          amount: typesData[type].amount || 0,
        };
      });
    });
    return months;
  }
   // Function to construct objects month-wise for each type
   function constructInteractionObjects(data) {
    const months = {};
    data.forEach((monthData) => {
      const typesData = monthData.details.reduce((acc, item) => {
        acc[item.interaction_type] = { count: item.count };
        return acc;
      }, {});
      // Initialize months object if not already present
      if (!months[monthData.month]) {
        months[monthData.month] = {}
        InteractionTypeProps.map(item => {
          months[monthData.month][item.type] = {count: 0}
        })
      }

      // Update months object with types data
      Object.keys(typesData).forEach((type) => {
        months[monthData.month][type] = {
          count: typesData[type].count,
        };
      });
    });
    return months;
  }

  // Function to get month-wise data for a specific newspaper
  function getDataForNewspaper(newspaperName) {
    const monthWiseData = constructObjects(graphData);
    const newspaperData = [];
    labels.forEach((label, index) => {
      const monthData = monthWiseData[index + 1] || {}; // Get data for the month or empty object if no data available
      const amountInCrores = (monthData[newspaperName]?.amount || 0) / 100000; // Convert amount to crores
      newspaperData.push(amountInCrores);
    });
    return newspaperData;
  }
  function getDataForInteractions(interactionType) {
    const monthWiseData = constructInteractionObjects(interactionsGraphData);
    const interactionData = [];
    labels.forEach((label, index) => {
      const monthData = monthWiseData[index + 1] || {}; // Get data for the month or empty object if no data available
      const amountInCrores = (monthData[interactionType]?.count || 0); // Convert amount to crores
      interactionData.push(amountInCrores);
    });
    return interactionData;
  }
  const fetchMonthWiseData = async (brand_id) => {
    try {
      let res = await api({
        url: "/market/get_monthwise",
        method: "POST",
        responseType: "json",
        data: {
          date: Math.round(selectedYear / 1000) < 10  ? Math.round(currentdate / 1000) : Math.round(selectedYear / 1000) ,
          brand_id,
          lang_id: parseInt(language),
          sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
        },
      });
      if (res.code === 200) {
        setGraphData(res.data);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchMonthWiseInteractsData = async (brand_id) => {
    let interactionResult = await api({
      url: "/accountManagement/get_monthwiseInteractions",
      method: "POST",
      responseType: "json",
      data: {
        date: Math.round(selectedYear / 1000),
        brand_id,
        lang_id: parseInt(language),
        sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
      }
    })
    if(interactionResult.code === 200){
      setInteractionsGraphData(interactionResult.data.monthGrapData)
      setTotalInteractionsGraphDetails(interactionResult.data.overallDetails)
    } else {
    Toast("error", interactionResult.data.message);
  }
  }

  const fetchMarketShare = async () => {
    setLoader(true);
    try {
      let res = await api({
        url: "/market/get_share_analysis",
        method: "POST",
        responseType: "json",
        data: {
          date: (Math.round(selectedYear / 1000) < 10 || initialRender) ? Math.round(currentdate / 1000) : Math.round(selectedYear / 1000),
          lang_id: parseInt(language),
          sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
          search:searchWord,
          active:activeStatus
        },
      });
      if (res.code === 200) {
        setMarketData(res.data);
        setIntialRender(false)
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if(!initialRender)
      fetchMarketShare();
  }, [selectedYear, language, searchWord, salesPerson_id, activeStatus]);
  const handleLanguage = (value) => {
    const newLanguage = value;
    setLanguage(newLanguage);

    // Define a mapping function to generate datasets based on filteredNewspapers
    const generateDatasets = (newspapers) => {
      return newspapers.map((np) => ({
        label: np.name,
        data: getDataForNewspaper(np.name), // Replace with your actual data fetching logic
        backgroundColor: np.background_color || "#333", // Use predefined or dynamically set colors
      }));
    };

    // Generate datasets based on filteredNewspapers
    const datasets = generateDatasets(filteredNewspapers);

    // Update monthGraphData with the generated datasets
    setMonthGraphData({
      ...monthGraphData,
      datasets: datasets,
    });
  };
  const generateInteractionGraph = () => {
      let datasets = InteractionTypeProps.map(item => {
        return {
          label: item.name,
          data : getDataForInteractions(item.type),
          backgroundColor: item.background_color || "#333",
        }
      })
    setMonthInteractionGraphData({
      ...monthInteractionGraphData,
      datasets
    })
  }

  useEffect(() => {
    handleLanguage(language);
  }, [graphData]);

  useEffect(() => {
    generateInteractionGraph()
  }, [interactionsGraphData])

  useEffect(() => {
    fetchNewsPapers();
    fetchMarketShare();
  }, []);

  useEffect(() => {
    if (brandId) fetchMonthWiseData(brandId);
  }, [brandId, language]);
  useEffect(() => {
    if(brandId) fetchMonthWiseInteractsData(brandId)
  }, [brandId])


  const downLoadData = async () => {
    try {
      let res = await api({
        url: "/market/get_share_analysis",
        method: "POST",
        responseType: "json",
        data: {
          date: Math.round(selectedYear / 1000),
          lang_id: parseInt(language),
          sales_id: selectedList.length > 0 ? selectedList.map(item => item.value) : undefined,
          search: searchWord,
          active:activeStatus
        },
      });
  
      if (res.code === 200) {
        let data = res.data;
        const workbook = XLSX.utils.book_new();
        let sales_people = selectedList || []
        if(sales_people.length === 0){
          sales_people.push({label: localStorage.getItem('name'), value: data[0].sales_person_id})
        }
        sales_people.forEach((salesPerson) => {
          const sheetData = [];
          const salespersonMarketData = data.filter(
            (item) => item.sales_person_id === salesPerson.value
          ); // Filter data for the salesperson
  
          // Headers
          sheetData.push([
            "Client Name",
            ...filteredNewspapers.flatMap((np) => [
              `${np.name} Amount`,
              `${np.name} %`,
            ]),
            "Total Budget",
          ]);
  
          // Data Rows
          salespersonMarketData.forEach((item) => {
            const row = [
              item.brand_name,
              ...filteredNewspapers.flatMap((np) => {
                const { amt, percentage } = calculateAmountAndPercentage(
                  item.data,
                  np.name,
                  item.amount
                );
                return [amt || 0, `${percentage}`];
              }),
              item.amount,
            ];
            sheetData.push(row);
          });
  
          // Convert to Sheet and Add to Workbook
          const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
          let match = salesPerson.label.match(/^(.+?)\(\s*(.+?)\s*\)$/); // Match the pattern
          let SaleTitleName = "",
            SaleTitleDesg = "";
          if (match) {
            SaleTitleName = match[1];
            SaleTitleDesg = match[2];
          }
          XLSX.utils.book_append_sheet(workbook, worksheet, SaleTitleName?.slice(0, 30) || SaleTitleName); // Sheet name is the salesperson's name
        });
  
        // Log workbook for debugging
        // console.log(workbook);
  
        // Export Workbook
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  
        // Log blob for debugging
        // console.log(excelBlob);
  
        // Trigger download
        saveAs(excelBlob, "salespersons_data.xlsx"); // Trigger download
      }
      else{
        Toast('error', "Something went wrong")
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) navigate("/");
    } finally {
      setLoader(false);
    }
  }
  

  const onSlSalesChange = (selected) => {
    setSelectedList(
      selected || []
    );
    localStorage.setItem("selectedSalesList", JSON.stringify(selected.map(item => item.value)))
    // if(salesPerson_id !== -1){
      setSalesPerson_id(salesUsersList?.length > 1 ? selected[selected.length -1]?.value || -1 : -1)
      setShowGraph(false)
      setClickIndex(-1)
      document.getElementById(`${selected[selected.length -1]?.value}`).scrollIntoView({ behavior: 'smooth' });
    // } 
  };
  const salesTabChange = async (sales_id) => {
    setMarketData([]);
    setSalesPerson_id(sales_id)
    setShowGraph(false)
    setClickIndex(-1)
  };

  const handleSortNewspaper = (newspaper) =>{
    if(newspaper === sortOn.sortBy){
      setSortOn({
        sortBy: newspaper,
        sortOrder: sortOn.sortOrder === 'asc' ? 'desc' : 'asc'
      })
      customSort(marketData, newspaper, newspaper, sortOn.sortOrder === 'asc' ? 'desc' : 'asc')
    }else{
      setSortOn({
        sortBy: newspaper,
        sortOrder: 'desc'
      })
      customSort(marketData, newspaper, newspaper, 'desc')
    }
  }


  const handleOverall = () => {
    if(sortOn.sortOrder === 'asc'){
      setSortOn({
        sortBy: 'amount',
        sortOrder: 'desc'
      })
      customSort(marketData, 'amount', null, 'desc')
    }else{
      setSortOn({
        sortBy: 'amount',
        sortOrder: 'asc'
      })
      customSort(marketData, 'amount', null, 'asc')

    }
  }

  function customSort(data, sortBy = 'amount', newspaperName = null, order = 'asc') {
    // Sorting function
    return data.sort((a, b) => {
      let amountA, amountB;
  
      // Determine the value to sort by
      if (newspaperName) {
        // Find the specific newspaper amount for each brand
        const newspaperDataA = a.data.find(d => d.newspaper_name === newspaperName);
        const newspaperDataB = b.data.find(d => d.newspaper_name === newspaperName);
  
        // If newspaper data exists, use its amount; otherwise, default to 0
        amountA = newspaperDataA ? newspaperDataA.amount : 0;
        amountB = newspaperDataB ? newspaperDataB.amount : 0;
      } else {
        // Sort by overall amount
        amountA = a.amount;
        amountB = b.amount;
      }
  
      // Calculate the difference and adjust for ascending or descending order
      if (order === 'asc') {
        return amountA - amountB;
      } else {
        return amountB - amountA;
      }
    });
  }
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }  
  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const handleRemove = (event) => {
    const sales_person_id = event;
    let tempArray = selectedList.filter(item => item.value !== +sales_person_id)
    setSelectedList(tempArray)
    let slideToId = salesPerson_id
    if(+sales_person_id === salesPerson_id){
      setSalesPerson_id(tempArray[0].value)
      slideToId = tempArray[0].value
    }
    localStorage.setItem("selectedSalesList", JSON.stringify(tempArray.map(item => item.value)))
    document?.getElementById(slideToId)?.scrollIntoView({ behavior: "smooth" });
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
      try {
        if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
        else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
      } catch (error) {
        console.error("Error @ closeUsersFilter", error)
      }
    }
  
  const startResize = (e, columnKey) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = columnWidths[columnKey] || e.target.parentElement.offsetWidth;
  
    const onMouseMove = (e) => {
      const newWidth = startWidth + (e.clientX - startX);
      setColumnWidths((prev) => ({
        ...prev,
        [columnKey]: Math.max(newWidth, 10), // minimum width
      }));
    };
  
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };
    
  
  return (
    <div className="marketShare">
      <div className="d-flex gap-3  flex-wrap my-2 items-center">
        <h3>Market Share Analysis</h3>
        <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" checked={activeStatus} onChange={()=>{setActiveStatus(!activeStatus)}} />
        <label class="form-check-label" for="flexSwitchCheckChecked">{activeStatus ? 'Active' : 'Inactive'}</label>
      </div>
        <div className="select-field"><YearlyCalendar startYear={2023} endYear={2100} /></div>
        <div className="select-field">
          {/* <label className="form-label">Language</label> */}
          <select
            className="form-select"
            onChange={(e) => handleLanguage(e.target.value)}
            value={language}
          >
            <option value={"0"}>All Languages</option>
            {languageOptions.map((lang) => (
            <option key={lang.id} value={lang.value}>{lang.label}</option>
            ))}
          </select>
        </div>
        <div className="w-6 h-6 bg-gray-200 hover:text-sky-400 rounded-md cursor-pointer items-center justify-center flex" onClick={downLoadData}>
          <sl-tooltip content="Download" placement="top">
      <SlIcon library="lucide" name="download" />
      </sl-tooltip>
        </div>
        {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div> : null}
        {/* {salesUsersList?.length > 1 ?
        <Select type="text"
          className={`z-20 mobHide`}
          name="sales_person_id"
          placeholder="Sales Person"
          value={selectedList}
          onChange={(selected) => {onSlSalesChange(selected)}}
          options={[ ...salesUsersList]}
          isMulti
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // or any other high value to ensure it is above other elements
            }),
            menuList: (provided) => ({
              ...provided,
              zIndex: 9999, // apply z-index to menuList if needed
            }),
          }}
        /> : null} */}
        {/* <div className="mobileOnly">
          <img
            src={filterSvg}
            className="ml-auto w-6"
            onClick={() => setShowFilter(true)}
            alt="filter"
          ></img>
        </div> */}
       
      </div>
      <SlTabGroup>
       
      {!(salesUsersList?.length > 1) && <SlTab
            onClick={() => {
              salesTabChange(-1);
            }}
            slot="nav"
            panel="general"
            active = {salesPerson_id === -1}
          >
            {localStorage.getItem("name")}
          </SlTab>}
          {selectedList.map(item => {
              return (
                <SlTab
                closable={selectedList.length > 1}
                onSlClose={() => handleRemove(item.value)}
                slot="nav"
                panel={item.value}
                onClick={() => {
                  salesTabChange(item.value);
                }}
                active = {salesPerson_id === item.value}
                id = {`${item.value}`}
              >
                {item.label}
              </SlTab>
              )
            })}
   </SlTabGroup>
        <table className="table table-bordered">
          <thead className="sticky top-0 bg-white z-10">
            <tr>
              <th className="mobHide">S.No</th>
              <th className="relative"
                  style={columnWidths.client ? { width: columnWidths.client } : undefined}>Client
              <div
                className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-gray-300"
                style={{ transform: "translateX(50%)" }} // Half outside the cell
                onMouseDown={(e) => startResize(e, "client")}
                onDoubleClick={() => {
                  setColumnWidths(prev => {
                    const updated = { ...prev };
                    delete updated["client"]; // remove that column key
                    return updated;
                  });
                }}
              ></div>
              </th>
              {filteredNewspapers.map((np) => (
                <th key={np.id} className="group relative " style={columnWidths[np.name] ? { width: columnWidths[np.name] } : undefined}>
                  <div className="d-flex gap-3 items-center">
                    <img
                      className="w-6"
                      src={np.logo}
                      alt={np.name}
                    />
                    <span className="mobHide">{np.name}</span>
                      {/* 👇 Resizer handle */}
                      <div
                        className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-gray-300"
                        onMouseDown={(e) => startResize(e, np.name)}
                        onDoubleClick={() => {
                          setColumnWidths(prev => {
                            const updated = { ...prev };
                            delete updated[np.name]; // remove that column key
                            return updated;
                          });
                        }}
                      ></div>
                  </div>
                  <div className="absolute top-3 right-2 group-hover:block">
                  <SlTooltip content="sort">
                    <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={() => handleSortNewspaper(np.name)} name={sortOn.sortOrder === 'desc' && sortOn.sortBy === np.name ? 'arrow-down' : 'arrow-up'}></SlIcon>
                  </SlTooltip>
                  </div>
                </th>
              ))}
              <th className="group relative">Total Budget
                 <div className="absolute top-3 right-2 group-hover:block">
                  <SlTooltip content="sort">
                    <SlIcon library="lucide" className="w-4 font-bold cursor-pointer" onClick={handleOverall} name={sortOn.sortOrder === 'desc' && sortOn.sortBy === 'amount' ? 'arrow-down' : 'arrow-up'}></SlIcon>
                  </SlTooltip>
                  </div></th>
            </tr>
          </thead>
          {marketData?.length && !loader ? (
            <tbody>
              {marketData?.map((item, index) => {
                return (
                  <>
                    <tr key={item.brand_id}>
                      <td className="mobHide">{index+1}</td>
                      <td>
                        <div
                          className="d-flex gap-2 items-center"
                          style={columnWidths.client ? { width: columnWidths.client, overflow: "hidden" } : undefined}
                          title={item.brand_name}
                        >
                          <sl-tooltip content={item.brand_name}>
                            <img
                              src={item?.url || getGenerateUrl(item.brand_name)}
                              title={item.brand_name}
                              className="h-6"
                              alt={item?.brand_name.slice(0,3)}
                            />
                          </sl-tooltip>
                          <span className={`truncate mobHide font-semibold`}>
                            {item.brand_name}
                          </span>
                        </div>
                      </td>
                      {filteredNewspapers.map((np) => {
                        const { amount, percentage } =
                          calculateAmountAndPercentage(
                            item.data,
                            np.name,
                            item.amount
                          );

                        return (
                          <td key={np.id}>
                            <div className="d-flex gap-2 flex-wrap items-center">
                              <span
                                className={`text-black text-xs min-w-[30px]`}
                              >
                                {amount}
                              </span>
                              <span
                                className={`px-2 py-1 rounded-xl text-xs`}
                                style={{
                                  backgroundColor: np.background_color,
                                  color: np.text_color,
                                }}
                              >
                                {percentage} %
                              </span>
                            </div>
                          </td>
                        );
                      })}
                      <td className="relative">
                        <div className="d-flex gap-[2px] mb-auto">
                          {filteredNewspapers.map((np) => {
                           
                            return (
                              <div
                                key={np.id}
                                style={{
                                  width: `${
                                    calculateAmountAndPercentage(
                                      item.data,
                                      np.name,
                                      item.amount
                                    ).percentage
                                  }%`,
                                  backgroundColor: np.background_color,
                                  color: np.text_color,
                                }}
                                className={`h-1 rounded-full`}
                              ></div>
                            );
                          })}
                        </div>
                        <div className="d-flex justify-between items-end">
                          <span>{formatAmount(item.amount)}</span>
                          <>
                            {!showGrpah && clickIndex !== index ? (
                              <div
                                className="togBtnShare"
                                onClick={async () => {
                                  setShowGraph(true);
                                  setClickIndex(index);
                                  setBrandId(item.brand_id);
                                }}
                              >
                                <img src={chevronDown} alt="down"></img>
                              </div>
                            ) : (
                              <div
                                className="togBtnShare"
                                onClick={() => {
                                  setShowGraph(false);
                                  setClickIndex(-1);
                                }}
                              >
                                <img src={chevronUp} alt="up"></img>
                              </div>
                            )}
                          </>
                        </div>
                      </td>
                    </tr>
                    {showGrpah && clickIndex === index && (
                      <tr>
                        <td
                          colSpan={`${
                            window.innerWidth <= 767
                              ? filteredNewspapers.length + 2
                              : filteredNewspapers.length + 3
                          }`}
                        >
                          <div
                            className={`d-flex ${
                              window.innerWidth <= 767 ? "flex-wrap" : ""
                            }`}
                          >
                            <div className="d-flex flex-wrap ">
                              <div className="budgetGraph">
                                <h5 className="mb-4">Overall Budget Gained</h5>
                                <div className="d-flex w-full gap-4 items-center">
                                  <div className="graphLabels">
                                    {filteredNewspapers.map((np) => {
                                      return (
                                        <label>
                                          {np.name}
                                          <SlIcon
                                            name="arrow-right"
                                            library="lucide"
                                            className="opacity-30"
                                          ></SlIcon>
                                        </label>
                                      );
                                    })}
                                  </div>
                                  <div className="graphBars">
                                    {filteredNewspapers.map((np) => {
                                      return (
                                        <div>
                                          <span
                                            style={{
                                              width: `${
                                                calculateAmountAndPercentage(
                                                  item.data,
                                                  np.name,
                                                  item.amount
                                                ).percentage * 1.5
                                              }%`,
                                              backgroundColor:
                                                np.background_color,
                                              color: np.text_color,
                                            }}
                                          ></span>
                                          <span>
                                            {
                                              calculateAmountAndPercentage(
                                                item.data,
                                                np.name,
                                                item.amount
                                              ).amount
                                            }
                                          </span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                              <div className="monthlyGraph">
                                <Bar
                                  options={options}
                                  data={monthGraphData}
                                  className="graphWidth"
                                />
                              </div>
                            </div>
                            <div className="d-flex flex-wrap ">
                              <div className="budgetGraph">
                                <h5 className="mb-4">Interactions</h5>
                                <div className="d-flex w-full gap-4 items-center">
                                  <div className="graphLabels">
                                    {InteractionTypeProps.map((item) => {
                                      return (
                                        <label>
                                          {item.name}
                                          <SlIcon
                                            name="arrow-right"
                                            library="lucide"
                                            className="opacity-30"
                                          ></SlIcon>
                                        </label>
                                      );
                                    })}
                                  </div>
                                  <div className="graphBars">
                                    {InteractionTypeProps.map((item) => {
                                      return (
                                        <div>
                                          <span
                                            style={{
                                              width: `${
                                                calculateAmountAndPercentageForInteractions(
                                                  item.type
                                                ).percentage * 1.5
                                              }%`,
                                              backgroundColor:
                                                item.background_color,
                                              color: item.text_color,
                                            }}
                                          ></span>
                                          <span>
                                            {
                                              calculateAmountAndPercentageForInteractions(
                                                item.type
                                              ).total_count
                                            }
                                          </span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                              <div className="monthlyGraph">
                                <Bar
                                  options={interactionGraphoptions}
                                  data={monthInteractionGraphData}
                                  className="graphWidth"
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                );
              })}
            </tbody>
          ) : !marketData?.length && !loader ? (
            <NoDataFound colspan="16" />
          ) : (
            <TableLoader colspan="16" />
          )}
        </table>
      {/* <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => { }}
      // style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex items-center gap-3 flex-wrap justify-between">
            <YearlyCalendar startYear={2023} endYear={2100} />
            <select
              className="form-select"
              onChange={(e) => handleLanguage(e.target.value)}
              value={language}
            >
              <option value={"0"}>All Languages</option>
              {languageOptions.map((lang) => (
                <option key={lang.id} value={lang.value}>{lang.label}</option>
              ))}
            </select>
            {salesUsersList?.length > 1 ?
              <Select type="text"
                name="sales_person_id"
                placeholder="Sales Person"
                value={selectedList}
                onChange={(selected) => { onSlSalesChange(selected) }}
                options={[...salesUsersList]}
                isMulti
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // or any other high value to ensure it is above other elements
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    zIndex: 9999, // apply z-index to menuList if needed
                  }),
                }}
              /> : null}
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer> */}
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    </div>
  );
}

export default MarketShareAnalysis;
